/* @flow */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { Table } from 'reactstrap';
import { createHTMLMarkup } from '../../utils';
// import cx from 'classnames';

// import classes from './ReportOutputParams.scss';

// const log = require('bows')('ReportOutputParams');

type PropsType = {
  tableData: Array<any>,
};

// eslint-disable-next-line react/prefer-stateless-function
export class ReportOutputParams extends React.Component<PropsType, *> {
  static defaultProps = {
    tableData: [
      [], [],
    ],
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const [header, ...rows] = this.props.tableData;

    const rowRows = rows.map(
      (s, i) => (
        <tr key={i}>
          {s.map((c, j) => <td key={j}>{createHTMLMarkup(c)}</td>)}
        </tr>
      ));

    return (
      <span>
        <Table size="sm" bordered striped>
          <thead>
            <tr>
              {header.map(s => <th key={s}>{s}</th>)}
            </tr>
          </thead>
          <tbody>
            {rowRows}
          </tbody>
        </Table>
      </span>
    );
  }
}

export default ReportOutputParams;



// WEBPACK FOOTER //
// ./src/components/ReportOutputParams/ReportOutputParams.js